import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface CoverageFilters {
  month?: string;
  country?: string;
  brand?: string;
  mediaTier?: string;
  sentiment?: string;
  category?: string;
}

export interface AppState {
  coverageFilters: CoverageFilters;
  selectedCoverageIds: string[];
  goalsActivePeriod: string;
  goalsActiveCountry: string;
  sidebarCollapsed: boolean;
}

const initialState: AppState = {
  coverageFilters: {},
  selectedCoverageIds: [],
  goalsActivePeriod: '',
  goalsActiveCountry: '',
  sidebarCollapsed: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCoverageFilters(state, action: PayloadAction<CoverageFilters>) {
      state.coverageFilters = action.payload;
    },
    resetCoverageFilters(state) {
      state.coverageFilters = {};
      state.selectedCoverageIds = [];
    },
    setSelectedCoverageIds(state, action: PayloadAction<string[]>) {
      state.selectedCoverageIds = action.payload;
    },
    setGoalsActivePeriod(state, action: PayloadAction<string>) {
      state.goalsActivePeriod = action.payload;
    },
    setGoalsActiveCountry(state, action: PayloadAction<string>) {
      state.goalsActiveCountry = action.payload;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
  },
});

export const {
  setCoverageFilters,
  resetCoverageFilters,
  setSelectedCoverageIds,
  setGoalsActivePeriod,
  setGoalsActiveCountry,
  setSidebarCollapsed,
} = appSlice.actions;

export default appSlice.reducer;
